@if (!history) {
  <div class="inline-flex justify-center w-full py-5" [thkLibProcessing]="true"></div>
}
@if (history) {
  @for (item of history; track item; let last = $last) {
    <div class="pb-6 ps-6 ms-2 relative border-l border-l-slate-300">
      <span class="absolute w-2 h-2 rounded-full bg-slate-300 left-[-4px] top-0"></span>
      @if (last || history.length === 1) {
        <span class="absolute w-2 h-2 rounded-full bg-slate-300 left-[-4px] bottom-[-4px]"></span>
      }
      <p class="text-sm text-neutral-900 font-normal mb-1">{{actionTitles[item.action]}}</p>
      <p class="text-xs text-neutral-700 font-normal mb-1">{{item.created_at | date:'dd MMMM, YYYY - hh:mm a'}}</p>
    </div>
  }
}
